import moment from 'moment'
import actions from './actions'
import { factoryReducer } from '../factory'

const initialState = {
  showFieldsForBodyClock: false,
  memberDetail: {
    dob: moment(),
  },
  memberCSIHistory: [],
  lastDeviceId: '',
  reportCSI: 0,
  weeklyReportPresenceData: [],
  weeklyReportData: {},
  deviceID: '',
  reportTTA: 0,
  memberSleepStagesHistory: {},
  reportMemberSleepStagesHistory: {},
  memberBodyClockData: {},
  memberBodyClockImage: '',
  memberProcessCImage: '',
  memberPRCImage: '',
  bodyclockSummary: [],
  patientProfileLoading: false,
  memberBodyClockGraphData: {},
  memberSleepSessions: [],
  weeklyTrendsData: [],
  reportSleepSessions: {},
  weeklyReportMetrics: {
    /*  'Start Time': [],
    'End Time': [], */
    'Total Sleep Time': [],
    'Sleep Efficiency': [],
    'Sleep Onset Latency': [],
    'REM Onset Latency': [],
    'Time in Bed': [],
    'Wake After Sleep Onset': [],
    Absence: [],
  },
  weeklyReportMetricsSummary: [],
  monthlyTrendsData: [],
  fortnightTrendsData: [],
  noiseGraphData: [],
  respiratoryGraphData: [],
  respiratoryVariableGraphData: [],
  motionGraphData: [],
  lightAMChartData: [],
  presenceData: [],
  hypnogramData: [],
  calendarDate: moment().format('YYYY-MM-DD'),
  reportCurrentDate: moment().format('YYYY-MM-DD'),
  historyStored: '',
  historyUpdated: '',
  getHistoryNotes: [],
  memberDiary: [],
  loading: false,
  nightByNightLoading: false,
  diaryLoading: false,
  noteLoading: false,
  noteListLoading: false,
  reportDataLoading: false,
  tabLoading: false,
  reportHypnogramData: [],
  reportPresenceData: [],
  reportMotionData: [],
  reportLightData: [],
  reportRespiratoryData: [],
  reportRespiratoryVData: [],
  reportNoiseData: [],
  reportDiaryData: [],
  reportAbsence: 0,
  memberAVGSleepMetrics: {},
  patientsMetrics: [],
  liveRespirationData: [],
  lastTwoHourData: [],
  lastRRData: {},
  pushDataToGraph: {},
  graphLoading: false,
  liveRscore: {},
  boxPlotData: {},
  deviceRawRR: {},
  boxPlotLoading: false,
  dates: [],
  currentDevice: {},
  socketConnectionData: false,
  thresholdModalVisible: false,
  // thresholdModalLoading: false,
  componentReload: false,
  modalVisibleAdd: false,
  getResidentStatus: [],
  hideRecentNotes: false,
}

export default factoryReducer(initialState, actions)
